const contactProfile = {
    contactProfile: {
        pageTitle: 'Contact Profile',
        pageDescription: 'Check and access to the registered Contact Profile',
        button: {
            delete: 'Delete',
            add: 'Add'
        }
    }
};
export default contactProfile;